"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const merge = require("deepmerge"),
  /**
  * Component to test theme injection methods, for development only
  *
  * @visibleName Test with Theme
  * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
  */
  TestWithTheme = props => {
    const {
        customTheme = {},
        name,
        testId
      } = props,
      theme = merge((0, _styles.useTheme)(), customTheme);
    let output = "Hey, Stranger!";
    if (name) {
      output = "Hello, " + name + "!";
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": testId
    }, output, " - ", theme?.identifier);
  };

// Define propTypes;
TestWithTheme.propTypes = {
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** String to be output */
  name: _propTypes.default.string,
  /** @ignore */
  testId: _propTypes.default.string
};

// Export component as default;
var _default = exports.default = TestWithTheme;